import React, {createContext, useContext} from 'react';
import {createPortal} from 'react-dom';
export const TodayLayoutContext=createContext(null);
export const useTodayLayout=()=>useContext(TodayLayoutContext);

// Legacy standalone pages keep their shell. In Today the persistent parent
// owns that box; display:contents retains local selectors and semantic labels.
export function TodayPageBox({as:Tag='div',children,...props}) {
 const layout=useTodayLayout();
 const Element=layout&&Tag==='main'?'div':Tag;
 return <Element {...props} data-today-embedded={layout?'':undefined}>{children}</Element>;
}
export function TodayHeader({children,...props}) {
 const layout=useTodayLayout();
 const header=<header {...props}>{children}</header>;
 return layout?(layout.header?createPortal(header,layout.header):null):header;
}
export function TodayNavigationRow({children,...props}) {
 return useTodayLayout()?null:<div {...props}>{children}</div>;
}

// Preserve page-scoped styles for controls moved into the shared header.
// Standalone pages already supply this scope and need no additional box.
export function TodayHeaderScope({className,children}) {
 return useTodayLayout()?<div className={className} data-today-embedded>{children}</div>:children;
}
